(function ($) {
	$('.social-sharing-link--print').on('click', function (e) {
		e.preventDefault();
		window.print();
	});
})(jQuery);
